// extracted by mini-css-extract-plugin
export var pageContainer = "styles-module--pageContainer--kOZjD";
export var pageTitle = "styles-module--pageTitle--1apz6";
export var pageContent = "styles-module--pageContent--1xDLF";